import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompletedProjectsData {
  projectDescription: string;
  projectLocation: string;
  projectName: string;
  projectImage: string;
}

interface initialStateType {
  ar: CompletedProjectsData;
  en: CompletedProjectsData;
}

const initialState: initialStateType = {
  ar: {
    projectDescription: '',
    projectLocation: '',
    projectName: '',
    projectImage: '',
  },
  en: {
    projectDescription: '',
    projectLocation: '',
    projectName: '',
    projectImage: '',
  },
};

const completedProjectsSlice = createSlice({
  name: 'completedProjects',
  initialState,
  reducers: {
    clearCompletedProjectsData: (state) => {
      state.ar = initialState.ar;
      state.en = initialState.en;
    },
    updateFieldValue: (
      state,
      action: PayloadAction<{
        language: 'ar' | 'en';
        field: string;
        value: any;
        isSameValue: boolean;
      }>,
    ) => {
      const { language, field, value, isSameValue } = action.payload;
      state[language][field] = value;
      if (isSameValue) {
        state['ar'][field] = value;
        state['en'][field] = value;
      }
    },
  },
});

export const { updateFieldValue, clearCompletedProjectsData } =
  completedProjectsSlice.actions;

export const completedProjectsReducer = completedProjectsSlice.reducer;

export interface CompletedProjectsState extends initialStateType {}
